module.exports = __webpack_public_path__ + "8a7955030bd0fe1f8ba449f50172d73c.svg";